<template lang="pug">
    div(class="image-list flex flex-wrap -m-3 mb-3")
        div(
            v-for="(imageBullet, index) in data"
            class="p-3 odd:pr-1 even:pl-1 md:odd:pr-3 md:even:pl-3 md:px-3"
            :class="layoutModeCSS"
        )
            div(
                class="pb-3"
                :class="{'w-full':mode === 'blocks'}"
            )
                img(
                    width="440"
                    height="308"
                    :key="imageBullet.image.key"
                    @click="showLightbox(index)"
                    :src="$getImageUrl(imageBullet.image.key, imageBullet.image.filename, 440, 308)"
                    :alt="imageBullet.image.title || ''"
                    class="border cursor-pointer"
                    loading="lazy"
                )
            div(class="content")
                div(v-html="imageBullet.title" class="font-bold uppercase pb-2")
                div(v-html="imageBullet.content" class="text-sm")
        Lightbox(
            v-if="isOpen"
            :items="lightboxItems"
            uniqueKey="imageList"
            :options="lightboxOptions"
            @close="hideLightbox"
        )
</template>

<script>
// TODO: If we pass blocks we need to show a large image, title bold under it( caps) and with text under that..  When you click on the image, you see
// a gallery with large images and titles
// TODO: We probably need to tweak the image based on mode (blocks vs bullets) and check of blocks is rendering larger that the source we are using on desktop (and adjust)
const Lightbox = () =>
    import(/* webpackChunkName: "photoswipe-lightbox" */ '@/components/overlay/photoswipeLightbox')

export default {
    components: {
        Lightbox,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
        mode: {
            type: String,
            default: 'bullets',
            validator(value) {
                return ['bullets', 'blocks'].includes(value)
            },
        },
        thirds: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            lightboxOptions: {
                index: 0,
                closeOnScroll: false,
                history: false,
                shareEl: false,
                fullscreenEl: false,
            },
        }
    },
    computed: {
        layoutModeCSS() {
            // return [`-${this.mode}`, this.thirds === true && this.mode === 'blocks' ? '-thirds' : '']
            let columnCSS = ''
            if (this.thirds === true && this.mode === 'blocks') {
                columnCSS = 'w-1/2 md:w-1/3'
            } else if (this.mode === 'blocks') {
                columnCSS = 'w-1/2'
            } else {
                columnCSS = 'is-12'
            }
            return columnCSS
        },
        isOpen() {
            return this.$overlay.state.activeOverlay === 'imageList'
        },
        lightboxItems() {
            return (
                this.data.map((imageData) => {
                    // create new image array with image objects in format that photoswipe likes
                    return {
                        src: this.$getImageUrl(
                            imageData.image.key,
                            imageData.image.filename,
                            1024,
                            768,
                            80,
                            'fff'
                        ),
                        w: 1024,
                        h: 768,
                        title: imageData.title,
                    }
                }) || []
            )
        },
    },
    created() {
        this.$overlay.registerUrlKey('imageList')
    },
    methods: {
        showLightbox(index) {
            this.$overlay.show('imageList')
            this.$set(this.lightboxOptions, 'index', index)
        },
        hideLightbox() {
            this.$overlay.hide()
        },
    },
}
</script>

<style lang="stylus" scoped>
.image-list
    >>> .pswp__caption
        .pswp__caption__center
            text-align center
</style>
